import { Box, Typography, Card, IconButton,Grid,CardContent ,CardActions} from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ViewInArIcon from '@mui/icons-material/ViewInAr'
import ImageIcon from '@mui/icons-material/Image'
import CollectionsIcon from '@mui/icons-material/Collections'
import {useNavigate} from 'react-router-dom'
import PeopleIcon from '@mui/icons-material/People';

const Widget = ({ type, amount, diff }) => {
  const navigate = useNavigate();

  const dataMap ={
    users:{
      title:'Users',
      icon: <PeopleIcon sx={{color: '#d50000', backgroundColor:'#fff'}}/>,
      link: 'See all users',
      path:'/users',
      isMoney:false,
    },
    models:{
      title: 'Active Subscriptions',
      icon: <ViewInArIcon sx={{color: '#ffeb3b', backgroudColor:'#fff'}}/>,
      isMoney:false,
    },
    predictions:{
    title: 'Predictions',
    icon: <ImageIcon sx={{color:'#43a047', backgroundColor:'#fff'}}/>,
    isMoney:false,
    link: 'View predictions',
    path:'/sets',
    },
    sets:{
      title: 'Sets',
      icon: <CollectionsIcon sx={{color: '#4527a0', backgroundColor:'#fff'  }}/>,
      link:'See all sets',
      path: '/sets',
      isMoney: false,
    }
  };

  const data = dataMap[type]
  if (!data) return null

    return (
      <Card sx={{ borderRadius:'12px', boxShadow:'3', height: {xs:75,sm:90},transition: '0.3s',
    '&:hover': {
      boxShadow: 6,
      transform: 'scale(1.01)'
    }}}>
        <CardContent>
          <Box sx={{display:'flex', gap:1,alignItems:'center'}}>
          {data.icon}
          <Typography sx={{fontWeight:'bold', fontSize:{xs:16, md:16, lg:18}, color:'#9e9e9e',  lineHeight: {
      md: data.title === 'Active Subscriptions' ? 1.1 : 1.4,
    }}} >
            {data.title}
          </Typography>
          </Box>
<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', textAlign:'right' }}>
          <Typography sx={{fontSize:{xs:22,sm:18,md:20,lg:22,}}}>
              {data.isMoney && '$'} {amount}
              </Typography>
          {data.link && data.path && (
          <><Typography onClick={() => navigate(data.path)} sx={{ textDecoration:'underline', cursor:'pointer',fontSize:{xs:14,sm:14,md:12,lg:14}, '&:hover': { color: 'primary.main' }}}>
              {data.link}
            </Typography>
              </>
          )}
          </Box>
          
      </CardContent>
      </Card>
  );
};

export default Widget;
